module.exports = __webpack_public_path__ + "4b2bd1ef83b9ab7efb9aabe7e8062073.png";